<template>
    <div class="modal-full">
        <div class="modal-header">
            <close-icon v-on:click="closeView"></close-icon>
            <h1>Create Knowlegebase Category</h1>
        </div>

        <div class="modal-body no-pad">
            <div class="flex h-full">
                <div class="account-sidebar h-full">
                    <div class="mb-4 text-center">
                        <span class="fa-layers fa-4x mb-3">
                            <i class="fa fa-circle"></i>
                            <i class="fas fa-user fa-inverse" data-fa-transform="shrink-6.5"></i>
                        </span>

                        <p class="text-lg font-light">New Category</p>
                    </div>

                    <div class="mb-3">

                    </div>
                </div>

                <div class="account-body">
                    <form class="profile-form">
                        <div class="form-title">
                            <p class="text-lg font-light">Category</p>
                        </div>

                        <div class="form-field">
                            <input type="text" v-model="category.kcat_title" @input="createSlug">
                            <label>Title</label>
                        </div>

                        <div class="form-field">
                            <input type="text" v-model="category.kcat_slug">
                            <label>URL Slug</label>
                        </div>

                        <div class="form-field">
                            <select v-model="category.kcat_container_id">
                                <option :value="null">No Container</option>
                                <option v-for="(container, index) in containers"
                                        :key="index"
                                        :value="container.id">
                                    {{ container.name }}
                                </option>
                            </select>
                            <label>Container</label>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="flex">
                <div class="left text-left">

                </div>

                <div class="right text-right">
                    <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    <button class="btn-primary" type="button" @click="saveForm">Save</button>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
export default {
    name: 'KnowledgebaseCategoriesCreate',
    props: {
        //
    },
    data() {
        return {
            category: {
                kcat_title: null,
                kcat_slug: null,
                kcat_container_id: null,
            },
            containers: [],
        }
    },
    components: {
        //
    },
    computed: {
        //
    },
    mounted() {
        this.setMetaTitle('Create Knowledgebase Category | JournoLink Control')
        this.loadData()
    },
    beforeDestroy() {
        //
    },
    methods: {
        loadData() {
            axios.get(route('containers.list'), {
                params: {
                    page: 1,
                    per_page: 1000,
                },
            })
                .then(response => {
                    this.containers = response.data.results && response.data.results.data
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.setMetaTitle('List Knowledgebase Categories | JournoLink Control')
            this.$root.goBack()
        },
        /**
         *
         */
        saveForm() {
            axios.post(route('knowledgebase.categories.create'), this.category)
                .then(response => {
                    this.category = response.data.category
                    this.$bus.$emit('alert.success', 'New category has been created')
                    this.$router.push({name: 'knowledgebase.categories.list', params: {newCategory: this.category}})
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
        /**
         * Create a slug from the title
         *
         * @return {String}
         */
        createSlug() {
            this.category.kcat_slug = this.category.kcat_title.toLowerCase().replace(/ /g, '-').replace(/[^a-z0-9\-]/g, '').substr(0, 100)
        },
    },
}
</script>

<style lang="less">
.account-sidebar {
    padding: 15px;
    width: 350px;
    font-size: 0.9rem;
    background: #f6f6f6;

    label {
        font-weight: bold;
        font-size: 0.8em;
        color: #999999;
    }

    p {
        margin-bottom: 0.5em;
    }
}

.account-activity {
    width: 250px;
    font-size: 0.9rem;
    padding: 15px;
}

.hidden-input {
    input {
        display: none;
        width: 100%;
    }

    .show {
        display: inline-block;
    }

    .hide {
        display: none;
    }

    .edit-field-link {
        text-decoration-line: underline;
        text-decoration-style: solid;
        color: #222222;
        word-wrap: break-word;
    }
}

.profile-form {
    .section-title {
        margin-top: 20px;
    }

    .form-title {
        margin-bottom: 20px;
    }
}
</style>
